import { Logo } from '/src/components'

import { SpinnerContainer } from './spinnerStyle'

const Spinner = () => <SpinnerContainer>
  <Logo hideTriangle size={''}/>
  <Logo hidePlanet size={''}/>
</SpinnerContainer>

export default Spinner
